
<div [innerHTML]="htmlScript">

</div>